module.exports = __webpack_public_path__ + "static/img/3.d047806.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/eng/3.png
// module id = cvsK
// module chunks = 0